import { FC, HTMLAttributes } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { SocialProfileType } from '../../../../types'
import { getInitials } from '../../../../utils'
import { StyledSocialProfileAvatar } from '.'

type Props = {
  profile: SocialProfileType
  size?: number
  inRow?: boolean
} & HTMLAttributes<HTMLDivElement>

const SocialProfileAvatar: FC<Props> = ({ profile, size = 42, inRow, ...rest }) => {
  return (
    <StyledSocialProfileAvatar
      type={profile.type}
      size={size}
      inRow={inRow}
      className="avatar"
      {...rest}
    >
      <div className="avatar-img">
        {profile.avatarUrl && <img src={profile.avatarUrl} alt={profile.username} />}
        {!profile.avatarUrl && getInitials(profile.username)}
      </div>
      {profile.status === 'expired' && (
        <div className="expired-indicator">
          <ExclamationCircleIcon />
        </div>
      )}
    </StyledSocialProfileAvatar>
  )
}

export default SocialProfileAvatar
